import React, { useEffect, useState } from "react";
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const useGetRealtimeUser = (userId) => {
  const [realTimeData, setRealTimeData] = useState({});

  useEffect(() => {
    if (userId) {
      onSnapshot(doc(db, "users", userId), (doc) => {
        // console.log(doc.data());
        const d = doc.data();
        setRealTimeData(d);
      });
    }
  }, [userId]);

  return { realTimeData };
};

export default useGetRealtimeUser